import { motion } from 'framer-motion';

export const EASE = [0.16, 1, 0.3, 1];

/* Masked line-by-line reveal that fires on load (hero) */
export function HeroLines({ lines, className = '', lineClassName = '', baseDelay = 0.1, stagger = 0.13 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={{ y: '112%' }}
            animate={{ y: '0%' }}
            transition={{ duration: 1.1, ease: EASE, delay: baseDelay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

/* Masked line-by-line reveal that fires on scroll into view.
   The observer sits on the outer (unclipped) wrapper — observing the
   translated child would keep it clipped and never trigger. */
export function ScrollLines({ lines, className = '', lineClassName = '', stagger = 0.1 }) {
  return (
    <motion.span
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.35 }}
    >
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            variants={{ hidden: { y: '112%' }, show: { y: '0%' } }}
            transition={{ duration: 1, ease: EASE, delay: i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
}

/* Generic fade-up reveal on scroll */
export function Reveal({ children, delay = 0, y = 28, className = '' }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

/* Small uppercase label with a rule, used above headings */
export function Eyebrow({ children, className = '' }) {
  return (
    <span className={`inline-flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.28em] text-turmeric ${className}`}>
      <span className="h-px w-8 bg-turmeric/60" aria-hidden="true" />
      {children}
    </span>
  );
}
